module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-3DVtuber.fc9cd4c2.png";